document.addEventListener('globo.formbuilder.form.submitted', e => {
    if (e.detail.formId === "68227") {
        const form = e.detail.form;
        if (form) {
            const footer = form.querySelector('.gfb__footer');
            if (footer) {
                footer.style.display = "none";
            }
        }
    }
});